import { Block } from 'baseui/block';
import { memo } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { User } from '../../types/users';
import { UserDetailData } from './UserDetailData';

type Props = {
  user: User;
};

function UserCardBody({ user }: Readonly<Props>) {
  const { css, theme } = useStyles();

  return (
    <Block
      className={css({
        padding: theme.sizing.scale400,
      })}
    >
      <UserDetailData user={user} />
    </Block>
  );
}

export default memo(UserCardBody);
